module.exports = __webpack_public_path__ + "static/media/notification.54fc2aca.svg";